<template>
  <div>
    <!-- Header Section Start -->
    <Header></Header>
    <!-- Header Section Start -->

    <!-- About Section Start -->
    <section id="about" class="section">
      <div class="container">
        <div class="section-header">
          <h3 class="section-subtitle wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">Who We Are</h3>
          <h2 class="section-title wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">About Us</h2>
        </div>
        <div class="row">
          <div class="col-md-6 wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
              <p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.</p>
          </div>
        </div>
        <div class="counters">
          <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3">
              <div class="wow fadeInUp" data-wow-delay=".2s">
                <div class="facts-item">
                  <div class="fact-count">
                    <h3>
                      <span class="counter">4452</span>
                    </h3>
                    <h4>Project Done</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
              <div class="wow fadeInUp" data-wow-delay=".4s">
                <div class="facts-item">
                  <div class="fact-count">
                    <h3>
                      <span class="counter">367</span>
                    </h3>
                    <h4>Happy Clients</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
              <div class="wow fadeInUp" data-wow-delay=".6s">
                <div class="facts-item">
                  <div class="fact-count">
                    <h3>
                      <span class="counter">965</span>
                    </h3>
                    <h4>Working Hours</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
              <div class="wow fadeInUp" data-wow-delay=".8s">
                <div class="facts-item">
                  <div class="fact-count">
                    <h3>
                      <span class="counter">280</span>
                    </h3>
                    <h4>Followers</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="img-about-out">
        <img src="@/assets/img/about-img.png" alt="">
      </div>
    </section>
    <!-- About Section End -->

    <!-- Services Section Start -->
    <section id="services" class="services section">
      <div class="container">
        <div class="section-header">
          <h3 class="section-subtitle wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">Let Us Help You</h3>
          <h2 class="section-title wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">Our Services</h2>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="service-box wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
              <div class="icon">
                <i class="icon-settings"></i>
              </div>
              <h3>
                <a href="#">Web Developer</a>
              </h3>
              <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="service-box wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="450ms">
              <div class="icon">
                <i class="icon-graph"></i>
              </div>
              <h3>
                <a href="#">Graphic Design</a>
              </h3>
              <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="service-box wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="550ms">
              <div class="icon">
                <i class="icon-camera"></i>
              </div>
              <h3>
                <a href="#">Photograph</a>
              </h3>
              <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="service-box wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="650ms">
              <div class="icon">
                <i class="icon-screen-tablet"></i>
              </div>
              <h3>
                <a href="#">App Development</a>
              </h3>
              <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Services Section End -->

    <!-- Portfolio Section -->
    <section id="portfolio" class="section">
      <!-- Container Starts -->
      <div class="container">
        <div class="section-header">
          <h3 class="section-subtitle wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">What We Do</h3>
          <h2 class="section-title wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">Works</h2>
        </div>
        <div class="row">
          <div class="col-md-12">
            <!-- Portfolio Recent Projects -->
            <div id="portfolio" class="row wow fadeInUp" data-wow-delay="0.8s">
              <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 mix marketing planning">
                <div class="portfolio-item">
                  <div class="portfolio-img">
                    <img src="@/assets/img/portfolio/img1.jpg" alt="" />
                  </div>
                  <div class="portfoli-content">
                    <div class="sup-desc-wrap">
                      <div class="sup-desc-inner">
                        <div class="sup-meta-wrap">
                          <a class="sup-title" href="#">
                            <h4>GeckPro</h4>
                          </a>
                          <p class="sup-description">Responsive Wordpress Onepage Template</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 mix planning">
                <div class="portfolio-item">
                  <div class="portfolio-img">
                    <img src="@/assets/img/portfolio/img2.jpg" alt="" />
                  </div>
                  <div class="portfoli-content">
                    <div class="sup-desc-wrap">
                      <div class="sup-desc-inner">
                        <div class="sup-meta-wrap">
                          <a class="sup-title" href="#">
                            <h4>GeckBlog</h4>
                          </a>
                          <p class="sup-description">Responsive Wordpress Onepage Template</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 mix research">
                <div class="portfolio-item">
                  <div class="portfolio-img">
                    <img src="@/assets/img/portfolio/img3.jpg" alt="" />
                  </div>
                  <div class="portfoli-content">
                    <div class="sup-desc-wrap">
                      <div class="sup-desc-inner">
                        <div class="sup-meta-wrap">
                          <a class="sup-title" href="#">
                            <h4>Remy</h4>
                          </a>
                          <p class="sup-description">Responsive Wordpress Onepage Template</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 mix marketing research">
                <div class="portfolio-item">
                  <div class="portfolio-img">
                    <img src="@/assets/img/portfolio/img4.jpg" alt="" />
                  </div>
                  <div class="portfoli-content">
                    <div class="sup-desc-wrap">
                      <div class="sup-desc-inner">
                        <div class="sup-meta-wrap">
                          <a class="sup-title" href="#">
                            <h4>Remy</h4>
                          </a>
                          <p class="sup-description">Responsive Wordpress Onepage Template</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 mix marketing planning">
                <div class="portfolio-item">
                  <div class="portfolio-img">
                    <img src="@/assets/img/portfolio/img5.jpg" alt="" />
                  </div>
                  <div class="portfoli-content">
                    <div class="sup-desc-wrap">
                      <div class="sup-desc-inner">
                        <div class="sup-meta-wrap">
                          <a class="sup-title" href="#">
                            <h4>GeckPro</h4>
                          </a>
                          <p class="sup-description">Responsive Wordpress Onepage Template</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 mix planning research">
                <div class="portfolio-item">
                  <div class="portfolio-img">
                    <img src="@/assets/img/portfolio/img6.jpg" alt="" />
                  </div>
                  <div class="portfoli-content">
                    <div class="sup-desc-wrap">
                      <div class="sup-desc-inner">
                        <div class="sup-meta-wrap">
                          <a class="sup-title" href="#">
                            <h4>Coelho</h4>
                          </a>
                          <p class="sup-description">Responsive Wordpress Onepage Template</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container Ends -->
    </section>
    <!-- Portfolio Section Ends -->

    <Footer></Footer>

    <!-- Go To Top Link -->
    <a href="#" class="back-to-top">
      <font-awesome-icon size="lg" :icon="['fas', 'arrow-up']" />
    </a>
  </div>
</template>

<script>
import $ from 'jquery'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: { Header, Footer },
  mounted () {
    this.backTopLink()
  },
  methods: {
    backTopLink () {
      let offset = 200
      $(window).scroll(function () {
        if ($(this).scrollTop() > offset) {
          $('.back-to-top').fadeIn(400)
        } else {
          $('.back-to-top').fadeOut(400)
        }
      })
      $('.back-to-top').click(function (event) {
        event.preventDefault()
        $('html, body').animate({
          scrollTop: 0
        }, 600)
        return false
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue